import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  Batch,
  getBatchesForCoursePayload,
  GetAllBatchesPayload,
  GetAllBatchesResponse,
  SaveBatchResponse,
  DeleteBatchPayload,
  SaveBatchOptions
} from './types'
import { RootState } from '../store'
import strings from '../../locale/en'
import ROUTES from '../../const/routes'
import history from '../../const/history'

export const getBatchesForCourse = createAsyncThunk(
  'batch/getBatchesForCourse',
  async ({
    coachingCentreId,
    courseId,
    branchId
  }: getBatchesForCoursePayload): Promise<Array<Batch>> => {
    const response = await api.get(
      `${apiEndpoints.getBatchesForCourse}?coachingCentreId=${coachingCentreId}&courseId=${courseId}&branchIds=${branchId}`
    )
    return response?.data
  }
)

export const getAllBatches = createAsyncThunk(
  'batch/getAllBatches',
  async ({
    pageNumber,
    pageSizeNumber,
    searchCriteria = {}
  }: GetAllBatchesPayload): Promise<GetAllBatchesResponse> => {
    const requestPayload = {
      pageNo: pageNumber,
      pageSize: pageSizeNumber,
      sortBy: 'createdAt',
      ascDesc: 'Desc',
      searchCriteria
    }
    const response = await api.post(apiEndpoints.getAllBatches, requestPayload)
    return {
      batches: response?.data?.content,
      pageSize: response?.data?.totalPages,
      currentPage: response?.data?.number
    }
  }
)

export const saveBatch = createAsyncThunk(
  'batch/saveBatch',
  async (
    { isEdit, batchId }: SaveBatchOptions,
    { getState }
  ): Promise<SaveBatchResponse> => {
    const {
      batch: { formValues }
    } = getState() as RootState

    const {
      validationMessages: {
        field: { required },
        batch: {
          selectInstitute,
          selectBranch,
          selectCourse,
          selectStaus,
          saveBatchFailed
        }
      }
    } = strings

    const formErrors: { [key: string]: any } = {
      batchName: formValues.batchName ? '' : required,
      coachingCenterId: formValues.coachingCenterId ? '' : selectInstitute,
      coachingCenterBranchId: formValues.coachingCenterBranchId
        ? ''
        : selectBranch,
      courseId: formValues.courseId ? '' : selectCourse,
      status: formValues.status ? '' : selectStaus,
      batchSize: formValues.batchSize ? '' : required,
      description: formValues.description ? '' : required
    }
    const canSubmit =
      Object.keys(formErrors).filter((key) => formErrors[key] !== '').length ===
      0

    if (canSubmit) {
      const payload = {
        additionalCourseId: formValues.additionalCourseId,
        batchEndDate: formValues.batchEndDate.toISOString().slice(0, 10),
        batchName: formValues.batchName,
        batchSize: formValues.batchSize,
        batchStartDate: formValues.batchStartDate.toISOString().slice(0, 10),
        coachingCenterBranchId: formValues.coachingCenterBranchId,
        coachingCenterId: formValues.coachingCenterId,
        courseId: formValues.courseId,
        description: formValues.description,
        endTiming: `${(formValues.endTiming as Date).getHours()}:${(
          formValues.endTiming as Date
        ).getMinutes()}`,
        startTiming: `${(formValues.startTiming as Date).getHours()}:${(
          formValues.startTiming as Date
        ).getMinutes()}`,
        status: formValues.status
      }
      const response = isEdit
        ? await api.put(`${apiEndpoints.deleteBatch}${batchId}`, payload)
        : await api.post(apiEndpoints.saveBatch, payload)
      if (response?.data) {
        history.push(ROUTES.BATCH_LIST)
        return response?.data
      }
      return { error: saveBatchFailed }
    } else {
      return { formErrors }
    }
  }
)

export const deleteBatch = createAsyncThunk(
  'batch/deleteBatch',
  async ({ batchId }: DeleteBatchPayload, { dispatch }): Promise<void> => {
    const response = await api.delete(`${apiEndpoints.deleteBatch}${batchId}`)
    if (response?.data) {
      dispatch(
        getAllBatches({
          pageNumber: 1,
          pageSizeNumber: 10
        })
      )
    }
  }
)
